import { Link } from "react-router-dom";
import Logo from "../../asset/images/home/Logo (1).png";
import FastTrackLogo from "../../asset/images/home/Fast Track logo 1.png";

function ForgotPassword() {
    return (
        <>
            {/* Header */}
            <header className="bg-white shadow-md">
                <div className="max-w-7xl mx-auto px-6 py-6">
                    <div className="flex justify-between items-center">
                        {/* Logo */}
                        <div className="flex items-center">
                            <img src={Logo} alt="READ 21 Logo" className="h-16 w-auto" />
                        </div>

                        {/* Navigation */}
                        <div className="flex items-center space-x-8">
                            <Link
                                to="/about"
                                className="bg-transparent text-gray-700 px-8 py-3 rounded-md font-medium text-lg hover:bg-primaryDark hover:text-white transition-colors"
                            >
                                About
                            </Link>
                            <Link
                                to="/register"
                                className="bg-transparent text-gray-700 px-8 py-3 rounded-md font-medium text-lg hover:bg-primaryDark hover:text-white transition-colors"
                            >
                                Enroll Today
                            </Link>
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Section */}
            <section className="py-12">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="bg-white rounded-xl shadow-xl p-10">

                        {/* Main Grid */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

                            {/* Left Side */}
                            <div className="flex justify-center">
                                <img src={FastTrackLogo} alt="READ 21 Logo" className="w-64 h-auto" />
                            </div>

                            {/* Right Side Form */}
                            <div className="space-y-5">
                                <div className="mb-12">
                                    <h1 className="text-3xl md:text-4xl font-semibold text-primary text-center mb-6">
                                        Reset Password
                                    </h1>
                                    <p className="text-center text-sm">
                                        Please provide your new password and confirm it below.
                                    </p>
                                </div>

                                {/* Password Field */}
                                <div className="relative">
                  <span className="absolute left-3 top-3 text-gray-400">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                    </svg>
                  </span>
                                    <input
                                        type="password"
                                        placeholder="Enter Password"
                                        className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                                        style={{ lineHeight: "1.4" }}
                                    />
                                    <button type="button" className="absolute right-3 top-3 text-gray-400">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                                        </svg>
                                    </button>
                                </div>

                                {/* Re-enter Password Field */}
                                <div className="relative">
                  <span className="absolute left-3 top-3 text-gray-400">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                    </svg>
                  </span>
                                    <input
                                        type="password"
                                        placeholder="Re-enter Password"
                                        className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                                        style={{ lineHeight: "1.4" }}
                                    />
                                    <button type="button" className="absolute right-3 top-3 text-gray-400">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                                        </svg>
                                    </button>
                                </div>

                                {/* Continue Button */}
                                <Link to="/login">
                                    <button className="w-full bg-primary hover:bg-primaryDark text-white font-semibold py-4 rounded-md transition-colors text-lg mt-6">
                                        Continue
                                    </button>
                                </Link>

                                {/* Login Link */}
                                <p className="text-center text-sm text-gray-600 mt-4">
                                    Already have an account?{" "}
                                    <Link to="/login" className="text-primary hover:underline font-medium">
                                        Log in now
                                    </Link>
                                </p>

                            </div>

                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-primary py-10">
                <div className="max-w-7xl mx-auto px-6 text-center">
                    <div className="mb-3">
                        <img src={Logo} alt="READ 21 Logo" className="mx-auto h-16 w-auto" />
                    </div>
                    <p className="text-white text-lg">Read 21 © 2025 - All Rights Reserved</p>
                </div>
            </footer>
        </>
    );
}

export default ForgotPassword;
